import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit as EditInterface } from '../../../../interfaces/reservation.interface';
import { AuthRoutes, Modules, RouteParamsTypes } from '../../../../enums';
import clsx from 'clsx';
import Spinner from '../../../../components/Spinner';
import Badge from '../../../../components/Badge';

interface DetailsProps {
  loading: boolean;
  formData: EditInterface;
}

const Details: React.FC<DetailsProps> = ({ loading, formData }) => {
  const { t } = useTranslation();

  const handleViewClick = (id: string) => {
    window.open(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <div className="card mb-6">
      <div className="card-body">
        {
          loading
            ?
            (
              <div className='text-center'>
                <Spinner />
              </div>
            )
            :
            (
              <>
                <div className="d-flex justify-content-between align-items-center pe-12 me-12">
                  <div className="d-flex">
                    <div className="avatar me-3 me-sm-4 d-flex align-items-center justify-content-center avatar-30">
                      <img width={30} height={30} src={`/assets/images/${formData.platformName}.svg`} />
                    </div>
                    <div>
                      <h6 className="mb-0 sm-4 text-primary cursor-pointer" onClick={() => handleViewClick(formData.propertyId)}>{formData.property}</h6>
                      <p className="mb-0 sm-4">{formData.city}</p>
                    </div>
                  </div>
                  <div className='border-start ps-5'>
                    <h6 className="mb-0 sm-4">{formData.guestName || "-"}</h6>
                    <p className="mb-0 sm-4">{t("reservations.list.pageTexts.table.totalGuests", { totalGuests: formData.totalGuests || "-" })}</p>
                  </div>
                  <div className='border-start ps-5'>
                    <h6 className="mb-0 sm-4">{t("reservations.edit.pageTexts.form.code")}</h6>
                    <p className="mb-0 sm-4">{formData.reservationCode || '-'}</p>
                  </div>
                  <div className='border-start ps-5'>
                    <h6 className="mb-0 sm-4">{t("reservations.edit.pageTexts.form.reservationStatus")}</h6>
                    <p className={clsx("mb-0 sm-4 h6 fw-bold", formData.reservationStatus === 'accepted' ? 'text-success' : 'text-danger')}>{formData.reservationStatusName || '-'}</p>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
                  <Badge
                    className="px-3 py-2 fw-medium fs-6"
                    variant="primary"
                    style={{
                      borderRadius: '0px 10px 0px 10px'
                    }}
                    text={formData.sourceName}
                  />
                </div>
              </>
            )
        }
      </div>
    </div>
  );
};

export default Details;
